import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import AddItem from '../../../nucleus/add-item/add-item';
import TaxAllocationItem from './TaxAllocationItem';
import { createTaxAllocation } from '../../../redux/actions/tax-allocations-actions';
import { selectTaxAdditionalCommissions } from '../../../redux/selectors/voucher-selectors';

const selectTaxAllocationIds = state => state.taxAllocations.taxAllocations.map(({ id }) => id);

const TaxAllocations = ({
  dealId,
  voucherId,
  allocationsLoaded,
  showValidation,
  tax_is_percent,
}) => {
  const taxAllocationIds = useSelector(selectTaxAllocationIds, shallowEqual);
  const taxAdditionalCommissions = useSelector(selectTaxAdditionalCommissions, shallowEqual);
  const dispatch = useDispatch();
  const hasTaxAdditionalCommissions = taxAdditionalCommissions.length > 0;
  const hasCreatedInitialTaxAllocationRef = useRef(false);

  const addTaxAllocation = () => {
    dispatch(createTaxAllocation({
      payment_group: 5,
      transaction: dealId,
    }));
  };

  useEffect(() => {
    if (
      allocationsLoaded
      && hasTaxAdditionalCommissions
      && !taxAllocationIds.length
      && !hasCreatedInitialTaxAllocationRef.current
    ) {
      hasCreatedInitialTaxAllocationRef.current = true;
      addTaxAllocation();
    }
    if (!hasTaxAdditionalCommissions) {
      hasCreatedInitialTaxAllocationRef.current = false;
    }
  }, [allocationsLoaded, hasTaxAdditionalCommissions, taxAllocationIds.length]);

  if (!hasTaxAdditionalCommissions) return null;

  return (
    <div className="outside-brokers">
      <h2>Tax Allocations</h2>
      {taxAllocationIds.map(id => (
        <TaxAllocationItem
          id={id}
          key={id}
          voucherId={voucherId}
          showValidation={showValidation}
          tax_is_percent={tax_is_percent}
        />
      ))}
      <AddItem label="Add Tax" onClick={addTaxAllocation} />
    </div>
  );
};

TaxAllocations.propTypes = {
  dealId: PropTypes.number.isRequired,
  voucherId: PropTypes.number.isRequired,
  allocationsLoaded: PropTypes.bool,
  showValidation: PropTypes.bool.isRequired,
  tax_is_percent: PropTypes.bool,
};

TaxAllocations.defaultProps = {
  allocationsLoaded: true,
  tax_is_percent: false,
};

export default TaxAllocations;